<template>
    <div class="news-headlines">
        <!-- <HeaderTop></HeaderTop> -->
        <!-- <Header :page="2"></Header> -->
        <!-- <el-breadcrumb separator="/" class="bread-crumb main">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item >教育资讯</el-breadcrumb-item>
        </el-breadcrumb> -->
        <div class="banner flex-align-center">
            <div v-for="(item,index) in bannerList" :key="index" >
            <div class="banner-box">
                <div class="paragraph">一分钟了解如何申请组考单位</div>
                <div class="details pointer" @click="goDetail('/groupdetail',item)">点击申请 &gt;</div>
            </div> 
                <!-- <img :src="item.cover" alt=""> -->
            </div>
            <!-- <div class="banner-box">
                <div class="paragraph">一分钟了解如何申请组考单位</div>
                <div class="details">查看详情 &gt;</div>
            </div> -->
            <!-- <img src="../../assets/home/banner.png" alt=""> -->
            <!-- <h1 class="title main"> -->
                <!-- “首都带首府” <br>
                京银教育合作“互联网+教育”模式        -->
            <!-- </h1> -->
        </div> 
        <div class="news-wrapper main flex-between">
            <div class="left-section">
                 <div class="school-filter">
                    
                    <div class="filter-row flex-layout">
                    <span class="filter-row-name">区域：</span>
                    <div class="filter-row-ul-wrapper" ref="filterArea">
                        <ul class="filter-row-ul" ref="filterAreaUl">
                        <li v-for="(item,index) in filterAreaList" :key="index"
                            @click="changeFilterProject(item,index,'Area')" :class="{'active':filterAreaId === item.id}"
                            class="filter-row-item csp">
                            {{item.name}}
                        </li>
                        </ul>
                    </div>
                    <i :class="[filterAreafold ? 'el-icon-arrow-up':'el-icon-arrow-down']" class="csp flod"
                        @click="flodFilterRow('Area')"></i>
                    </div>
                    <div class="filter-row flex-layout">
                    <span class="filter-row-name">组考单位性质：</span>
                    <ul class="filter-row-ul">
                        <li v-for="(item,index) in filterStatusList" :key="index" @click="changeFilterProject(item,index,'Status')"
                        :class="{'active':filterStatusId === item.id}" class="filter-row-item csp">
                        {{item.name}}
                        </li>
                    </ul>
                    </div>
                </div>
                <div class="search flex-align-between">
                    <span>组考单位名录</span>
                    <span><el-input size="medium" @keyup.enter.native="search" @input="search" v-model.trim="searchData" placeholder="请输入内容" suffix-icon="el-icon-search"> </el-input></span>
                </div>
                <ul class="news-lists">
                    <li class="flex-align-between" v-for="(li, index) in lists" :key="index" @click="getoDetail(li)">
                        <img :src="li.cover" alt="" v-show="li.cover !== undefined">
                        <div class="article">
                            <h3 class="f16 wes">{{li.title}}</h3>
                            <!-- <p class="f12 wes-2">{{li.introduction}}</p> -->
                            <div class="summary flex-align">
                                <span>地址：{{li.source}}</span>
                                <span>负责人：{{li.author}}</span>
                                <span>电话：{{li.introduction}}</span>
                            </div>
                        </div>
                        <!-- <div class="time">
                              {{li.createTime}}
                        </div> -->
                    </li>
                </ul>
               
               <!-- <div class="more-btn" v-show="showBtn" @click="getlist()">
                   查看更多
               </div>
               <div class="nothing" v-show="!showBtn" >
                   <hr><span>已无更多</span><hr>
               </div>  -->
               <empty :show="lists && lists.length === 0"></empty>
               <div v-if="lists.length > 0" class="page-box">
                <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    layout="prev, pager, next"
                    :total="total">
                </el-pagination>
                </div>
             

            </div>
           <!-- <focusBar></focusBar> -->
        </div>    
        <footer-view></footer-view>
        <!-- <scorllTop></scorllTop> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            currentPage: 1,
            lists:[],
            searchData: '',
            bannerList:[],
            showBtn:true,
            total:null,
            pageNum:1,
            pageSize:10,
            filterAreaId: null,
            filterAreafold: false,
            filterAreaList: [{
                id: null,
                    name: '全部'
                },{
                    id: 1,
                    name: '东城区'
                },{
                    id: 2,
                    name: '西城区'
                },{
                    id: 3,
                    name: '朝阳区'
                },{
                    id: 4,
                    name: '丰台区'
                },{
                    id: 5,
                    name: '石景山区'
                },{
                    id: 6,
                    name: '海淀区'
                },{
                    id: 7,
                    name: '顺义区'
                },{
                    id: 8,
                    name: '通州区'
                },{
                    id: 9,
                    name: '大兴区'
                },{
                    id: 10,
                    name: '房山区'
                },{
                    id: 11,
                    name: '门头沟区'
                },{
                    id: 12,
                    name: '昌平区'
                },{
                    id: 13,
                    name: '平谷区'
                },{
                    id: 14,
                    name: '密云区'
                },{
                    id: 15,
                    name: '怀柔区'
                },{
                    id: 16,
                    name: '延庆区'
                },
            ],
            filterStatusId: null,
            filterStatusList: [{
                    id: null,
                    name: '全部'
                },{
                    id: 1,
                    name: '公立校'
                }, {
                    id: 2,
                    name: '培训机构'
                }],
        }
    },
    watch: {
        searchData:function(newnew,oldold){
            if(newnew == ""){
                // 发请求回到初始列表数据状态
                console.log("搜索框没东西了，回复初始状态");
            }
        }
    },
    methods: {
        // 切换筛选项
      changeFilterProject(item, index, type) {
        this[`filter${type}Id`] = item.id
        this.getslist();
      },
      flodFilterRow(type) {
        this[`filter${type}fold`] = !this[`filter${type}fold`];
        this.$refs[`filter${type}`].style.height = this[`filter${type}fold`] ?
          `${this.$refs[`filter${type}Ul`].clientHeight}px` : '50px';
      },
       //获取项目下课程列表
    //   async getSchoolCourseList() {
    //     if (this.activeName === "0") return;
    //     let params = {
    //       projectId: this.filterProjectId,
    //       page: this.pages.currentPage,
    //       limit: this.pages.pageSize,
    //       courseType: this.filterTypeId,
    //       courseStatues: this.filterStatusId,
    //       orderType: this.activeSortId,
    //       subjectId: this.filterSubjectId,
    //     }
    //     // console.log(params);
    //     let resData = await this.$Api.Course.getSchoolCourseList(params)
    //     // console.log(resData)
    //     this.courseList = []
    //     if (!resData.data || resData.data.list.lenght <= 0) return
    //     this.courseList = resData.data.list;
    //     this.pages.total = resData.data.totalCount;
    //   },
       search(){
        // 控制一下，如果用户没输入东西就不去搜索
        if(this.searchData == ""){
            this.getlist()
            return
        }else{
            // 把searchData带着，发请求获取有关联的数据并呈现在页面中
            // console.log("带着关键字交给后端搜索",this.searchData);
            this.getslist()
        }
        },
        async getbannerList() {
            let params = {
                clazz:15,
                pageSize:1,
                pageNum:1,
            }
            let resData = await Api.Home.getNewsList(params);
            this.bannerList = resData.rows;
        },
        async getslist() {
            let params = {
                clazz:9,
                pageSize:this.pageSize,
                pageNum:this.pageNum,
                title:this.searchData,
                newArea:this.filterAreaId,
                unitNature:this.filterStatusId

            }
            let resData = await Api.Home.getList(params);
            this.total = resData.total;
            this.lists = resData.rows;

            // if(resData.rows.length === 0 ) {
            //     this.showBtn = false;
            // }
            // this.lists = this.lists.concat(resData.rows);
        },
         handleCurrentChange(val) {
            this.pageNum = val
            this.getlist()
        },
        async getlist() {
            let params = {
                clazz:9,
                pageSize:this.pageSize,
                pageNum:this.pageNum,

            }
            let resData = await Api.Home.getNewsList(params);
            this.total = resData.total;
            this.lists = resData.rows;
            // resData.rows.forEach((item, index) => {
            //      if(item.image !== undefined) {
            //          item.urls = this.imageURL + item.image
            //      } else {
            //          item.urls = undefined;
            //      }
            // })
            // if(resData.rows.length === 0 ) {
            //     this.showBtn = false;
            // }
            
        },
         async goDetail(path,item) {
            if(item.hasOwnProperty('url')) {
                window.open(item.url);
            } else {
                let msg = {id:item.dId,type:item.clazz}
                this.$router.push(path ,msg)
            }
        },
        async getoDetail(item) {
             if(item.hasOwnProperty('url')) {
                window.open(item.url);
            } else {
            let msg = {id:item.dId,clazz:item.clazz}
            this.$router.push('/list/information/detail/'+item.dId ,msg)
            // Common.goPage(this, '/news/work/'+item.articleId,msg)
            }
        }
    },
    mounted() {
        this.getlist();
        this.getbannerList()
    }
}
</script>

<style lang="less">
     @import "./less/news_common.less";
     @import "./less/news_information.less";
</style>